import { elements } from '@ecosystem/newron-design-system';
import classnames from 'classnames';

export type ChangeInfoTextProps = {
  isPositiveGrowth: boolean;
  text: string;
  showIcon?: boolean;
};

const ChangeInfoText: React.FC<ChangeInfoTextProps> = ({ isPositiveGrowth, text, showIcon = false }) => {
  const { Icon } = elements;
  const { ArrowTopRight, ArrowBottomRight } = Icon.icons;

  return (
    <div className="flex" data-test-id="growth-change">
      {showIcon && (
        <Icon size="md" color={isPositiveGrowth ? 'success' : 'error'} testId="change-color-icon">
          {isPositiveGrowth ? <ArrowTopRight /> : <ArrowBottomRight />}
        </Icon>
      )}
      <div
        className={classnames({
          'text-ui-green': isPositiveGrowth,
          'text-ui-red': !isPositiveGrowth,
        })}
      >
        {text}
      </div>
    </div>
  );
};

export default ChangeInfoText;
